module.exports = __webpack_public_path__ + "img/img_stamp_bw.573daa0a.png";